import { render, staticRenderFns } from "./lisa-questionnaire.vue?vue&type=template&id=33cb694f&scoped=true&"
import script from "./lisa-questionnaire.vue?vue&type=script&lang=js&"
export * from "./lisa-questionnaire.vue?vue&type=script&lang=js&"
import style0 from "./lisa-questionnaire.vue?vue&type=style&index=0&id=33cb694f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cb694f",
  null
  
)

export default component.exports